// src/pages/TestPushNotification/index.tsx
import React, { useState } from 'react';
import { Button, Typography, Box } from '@mui/material';
import apiCall from '../../utils/api'; // Assuming apiCall is available here

const TestPushNotificationPage: React.FC = () => {
  const [responseMessage, setResponseMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleSendNotification = async () => {
    setLoading(true);
    setResponseMessage(null);
    setError(null);

    const payload = {
      user_id: 2, // Assuming a fixed user_id for testing as per curl command
      title: "Test Title",
      message: "This is a test push notification.",
      data: {
        testing_key: "push notification"
      }
    };

    try {
      const response = await apiCall<{ status: boolean; message: string }>(
        'POST',
        '/api/test-push-notification/',
        payload
      );
      setResponseMessage(response.data.message);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to send test notification.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Test Push Notification
      </Typography>
      <Typography variant="body1" paragraph>
        Click the button below to send a test push notification to user ID 2.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSendNotification}
        disabled={loading}
      >
        {loading ? 'Sending...' : 'Send Test Notification'}
      </Button>

      {responseMessage && (
        <Typography variant="body1" color="success.main" sx={{ mt: 2 }}>
          {responseMessage}
        </Typography>
      )}

      {error && (
        <Typography variant="body1" color="error.main" sx={{ mt: 2 }}>
          Error: {error}
        </Typography>
      )}
    </Box>
  );
};

export default TestPushNotificationPage;
